import e from "./ghl-ui.es1507.js";
import i from "./ghl-ui.es1466.js";
import m from "./ghl-ui.es1505.js";
function a(r, o) {
  i(2, arguments);
  var t = m(o);
  return e(r, -t);
}
export {
  a as default
};
